module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<!-- insert title and Breadcrumb templates -->\r\n\r\n")
    ; 
var constants = require('Constants.js').default;

    ; __append("\r\n\r\n<div class=\"page-title\">\r\n    <div class=\"row\">\r\n        <div class=\"col col-sm-12\">\r\n            <h1>Reports Overview</h1>\r\n        </div>\r\n    </div>\r\n    <ol class=\"breadcrumb\">\r\n        <li class=\"active\">Reports</li>\r\n    </ol>\r\n</div>\r\n\r\n<div class=\"row\">\r\n    <div class=\"col col-sm-4\">\r\n        <h2>")
    ; __append(escapeFn(titleSection ))
    ; __append("</h2>\r\n        <div class=\"panel panel-default\">\r\n            <div id=\"recentEdits\" class=\"panel-body\">\r\n                <ul class=\"list\">\r\n                    ")
    ;  _.forEach(reports, function(report) { 
    ; __append("\r\n                        <li data-id=\"")
    ; __append(escapeFn(report['@id'] ))
    ; __append("\" data-isprivate=\"")
    ; __append(escapeFn(report['@isPrivate']))
    ; __append("\">")
    ; __append(escapeFn( report['@name'] ))
    ; __append("</li>\r\n                    ")
    ; }); 
    ; __append("\r\n                </ul>\r\n            </div>\r\n        </div>\r\n    </div>\r\n    <div class=\"col col-sm-4\">\r\n        <h2>Favorites</h2>\r\n        <div class=\"form-group\">\r\n            <div class=\"panel panel-default\">\r\n                <div id=\"favoriteForms\" class=\"panel-body\">\r\n                    <ul class=\"list\">\r\n                        ")
    ;  _.forEach(currentFavoritesList, function(form) {
    ; __append("\r\n                            <li data-id=\"")
    ; __append(escapeFn(form['@id'] ))
    ; __append("\">")
    ; __append(escapeFn(form['@name']))
    ; __append("</li>\r\n                        ")
    ;  });
    ; __append("\r\n                    </ul>\r\n                </div>\r\n            </div>\r\n            <button class=\"btn btn-default hvr-glow tbl-icon\" title=\"Add Favorite Report\" id=\"addReport\" name=\"addReport\"><i class=\"fa pf-add\"></i></button>\r\n            <button class=\"btn btn-default hvr-glow tbl-icon\" title=\"Remove Favorite Report\" id=\"removeReport\" name=\"removeReport\"><i class=\"fa pf-delete icon-gradient\"></i></button>\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"col col-sm-4\">\r\n        <h2>Report Information</h2>\r\n        <div class=\"listSelected dropdown\">\r\n            <button style=\"font-weight: normal;\" class=\"btn btn-default dropdown-toggle button-as-dropdown\" type=\"button\" id=\"dropdownMenu1\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"true\">\r\n                Select a Report\r\n                <span class=\"caret\"></span>\r\n            </button>\r\n            <ul class=\"list dropdown-menu select-list\" aria-labelledby=\"dropdownMenu1\" style=\"max-height: 252px; overflow: auto\">\r\n                 ")
    ;  _.forEach(privateReports, function(report) {  
    ; __append("\r\n                     <li class=\"")
    ; __append(escapeFn(report['@class']))
    ; __append("\" data-id=\"")
    ; __append(escapeFn(report['@id'] ))
    ; __append("\">")
    ; __append(escapeFn( report['@name'] ))
    ; __append("</li>\r\n                ")
    ; }); 
    ; __append("\r\n                <li role=\"separator\" data-id=\"none\" class=\"divider\"></li>\r\n                <li class=\"form-instances\" data-id=\"all\" linkId=\"all\">All ")
    ; __append(escapeFn(privateReports.length))
    ; __append(" reports</li>\r\n            </ul>\r\n        </div>\r\n        <h3>Report Details (Datasource)</h3>\r\n        <div class=\"panel panel-default\" style=\"height:100px;\">\r\n            <div class=\"panel-body\">\r\n                <ul class=\"list\">\r\n                    ")
    ;  _.forEach(dependenceList, function(report) { 
    ; __append("\r\n                        <li data-id=\"")
    ; __append(escapeFn(report['@id']))
    ; __append("\" data-guid=\"")
    ; __append(escapeFn(report['@guid']))
    ; __append("\" data-type=\"")
    ; __append(escapeFn(report['@type']))
    ; __append("\"> ")
    ; __append(escapeFn(report['@name']))
    ; __append("</li>\r\n                    ")
    ; }); 
    ; __append("\r\n                </ul>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n\r\n<div class=\"row\">\r\n    <div class=\"col col-md-6\">\r\n        <h2>Information</h2> \r\n        <span>Reports display the data collected by apps.</span>\r\n        <span>Reports can also serve as portal pages or drill-down</span>\r\n        <span>dashboards that take you to other apps</span>\r\n        <span>and reports.\r\n        <span>Create a new report, configure its</span>\r\n        <span>datasource to point to a published app and </span>\r\n        <span>design it according to your requirements.</span> \r\n    </div>\r\n    <div class=\"col col-md-6\">\r\n        <h2>Reports Help</h2> \r\n        <span><a href=\"")
    ; __append(escapeFn(constants.HELP_EDIT_REPORT ))
    ; __append("\" target=\"_blank\">\r\n            Edit Reports</a></span> \r\n    </div>\r\n</div>")
  }
  return __output;

}